<template>
  <v-dialog fullscreen v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Cari Hareket Detay
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text id="printCurrentActionDetail">
        <div>
          <div class="mb-4 d-flex justify-content-start py-5">
            <div class="d-flex w-100 flex-column ps-4" v-if="currentActionProp"
                 style="font-size:13px;border-left: 5px solid grey;border-bottom: 5px solid grey">
              <div class="py-3"><b>Cari Kodu : </b> {{ currentActionProp.currentCode }}</div>

              <div class="py-3"><b>Cari Adı : </b> {{ currentActionProp.currentName }}</div>

              <div class="py-3"><b>İşlem Tarihi : </b>{{ formattedDate(currentActionProp.actionDate, "DD-MM-YYYY") }}</div>

              <div class="py-3"><b>Vade Tarihi : </b> {{ formattedDate(currentActionProp.expiryDate, "DD-MM-YYYY") }}</div>

              <div class="py-3"><b>Fatura Numarası : </b> {{ currentActionProp.documentNumber }}</div>

            </div>
          </div>
          <b-table
              :items="currentActionDetailList"
              :fields="currentActionDetailListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="currentActionDetailListLoading"
              head-row-variant="info"
              style="font-size:12px"
              table-variant="white"
              show-empty
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(costDate)="data">
              {{ formattedDate(data.item.costDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(expiryDate)="data">
              {{ formattedDate(data.item.expiryDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(series)="data">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="amber darken-2"
                        @click="openSeriesDialog(data.item)"

                    >
                      <v-icon>mdi-view-list-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Seri Listesi</span>
                </v-tooltip>
              </div>
            </template>
            <template #cell(process)="data" class="exclude-print">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="amber darken-2"

                    >
                      <v-icon>mdi-contactless-payment-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>E-Fatura</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="indigo darken-2">
                      <v-icon>mdi-text-box-search-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Stok Detay</span>
                </v-tooltip>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
          </b-table>
        </div>
        <div>
          <div class="row justify-content-end">
            <div class="col-lg-4 table-responsive">
              <table class="table table-sm mb-0">
                <tbody>
                <tr>
                  <td>Brüt Tutar</td>
                  <td class="text-right">{{ (currentActionDetailListTotal.grossAmount) }}</td>
                </tr>
                <tr>
                  <td>İskonto</td>
                  <td class="text-right">{{ (currentActionDetailListTotal.discount) }}</td>
                </tr>
                <tr>
                  <td>Ara Toplam</td>
                  <td class="text-right">{{ (currentActionDetailListTotal.subTotal) }}</td>
                </tr>
                <tr>
                  <td>KDV</td>
                  <td class="text-right">{{ (currentActionDetailListTotal.vat) }}</td>
                </tr>
                <tr>
                  <th>Toplam Tutar :</th>
                  <th class="text-right">{{ (currentActionDetailListTotal.totalAmount) }}</th>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="py-3 d-flex justify-content-center">
          <PrintPage :divId="'printCurrentActionDetail'"></PrintPage>
          <ExcelExport
              :dataProp="currentActionDetailList"
              :columnProp="currentActionDetailListHeaders"
              :fileNameProp="this.currentActionProp ? 'Cari Hareket Detay ' + this.currentActionProp.documentNumber : ''"
          >

          </ExcelExport>

        </div>
        <CurrentActionDetailsSeriesDialog :showSeriesDialog="showSeriesDialog" :stockCode="stockCode" @seriesDialogChange="data => showSeriesDialog = data"></CurrentActionDetailsSeriesDialog>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex';
import {formattedDate} from "@/momentHelper";
import {numberConverter, printView} from "../../../../helpers";
import ExcelExport from "@/components/shared/ExcelExport";
import PrintPage from "@/components/shared/PrintPage";
import CurrentActionDetailsSeriesDialog from "@/components/current/dialogs/CurrentActionDetailsSeriesDialog.vue";

export default {
  name: "CurrentActionsDialog",
  components: {
    ExcelExport,
    PrintPage,
    CurrentActionDetailsSeriesDialog,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentActionProp: {
      type: Object,
      default: () => {
      }
    },
    reportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("current", ["currentActionDetailList", "currentActionDetailListHeaders", "currentActionDetailListLoading", "currentActionDetailListTotal","seriesList","stockCodeList","getStockCodeList","noSeriesMessage"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
      stockCodeList() {
        return this.getStockCodeList;
      }
    },
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      showSeriesDialog: false,
      stockCode: "",
    };
  },
  methods: {
    numberConverter,
    ...mapActions("current", ["fetchCurrentActionDetailList", "fetchCurrentActionListTotal","fetchSeries"]),
    ...mapMutations("current", ["setCurrentActionDetailList"]),
    printView,
    formattedDate,
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '';
    },
    closeDialog() {
      this.dialog = false;
    },
    async initCurrentActionDetailList() {
      await this.fetchCurrentActionDetailList({
        params: {
          documentNumber: this.currentActionProp.documentNumber,
          currentType: this.currentActionProp.currentType,
          currentCode: this.currentActionProp.currentCode,
          ...(!(this.reportDbNameProp === "" || this.reportDbNameProp == null)) && {reportDbName: this.reportDbNameProp}
        },
        body: {}
      });

    },
    async getCurrentActionTotalList() {
      await this.fetchCurrentActionListTotal({
        params: {
          documentNumber: this.currentActionProp.documentNumber,
          currentCode: this.currentActionProp.currentCode,
          ...(!(this.reportDbNameProp === "" || this.reportDbNameProp == null)) && {reportDbName: this.reportDbNameProp}
        },
        body: {}
      });
    },
    async _fetchSeries(stockCode,documentNumber) {
      await this.fetchSeries({
        params: {
          stockCode: stockCode,
          documentNumber: documentNumber
        },
        body: {}
      });
    },
    openSeriesDialog(data) {
      this._fetchSeries(data.stockCode,data.documentNumber);
      this.stockCode = data.stockCode;
      this.showSeriesDialog = true;
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal) {
        this.initCurrentActionDetailList();
        this.getCurrentActionTotalList();
      } else {
        this.setCurrentActionDetailList([])
      }
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
  }
}
</script>

<style scoped>

</style>